import API from '../../api/tracks'

const store = {
  namespaced: true,
  state: () => ({
    items: []
  }),
  mutations: {
    set(state, items) {
      state.items = items
    },
    edit(state, {id, data}) {
      Object.assign(state.items.find(item => item._id === id), data)
    }
  },
  actions: {
    async fetch(context, query) {
      const items = await API.list(query)
      context.commit('set', items)
    },
    async edit(context, { id, data }) {
      context.commit('edit', {id, data})
      await API.edit(id, data)
    },
  },
  getters: {
    items: state => {
      return state.items && state.items.filter(i => i.track.type === 'LineString').map(item => {
        item.distanceInKm = item.distance && (item.distance/1000).toFixed(3)
        item.polyline = {
          color: 'green',
          latlngs: item.track && item.track.coordinates && item.track.coordinates.map(([lat, long]) => [long, lat]) || []
        }
        return item
      })
    }
  }
}

export default store